import { render, staticRenderFns } from "./AboutPageMenu.vue?vue&type=template&id=2d782b56"
import script from "./AboutPageMenu.vue?vue&type=script&lang=js"
export * from "./AboutPageMenu.vue?vue&type=script&lang=js"
import style0 from "./AboutPageMenu.vue?vue&type=style&index=0&id=2d782b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports